<template>
    <v-btn v-if="!isGuest"
           ref="gamut-compress-button"
           v-tippy
           content="ACES Reference Gamut Compression"
           :disabled="isDisabled"
           @click="setGamutCompress"
    >
        <v-icon class="material-symbols-outlined">format_color_fill</v-icon>
    </v-btn>
</template>

<script>
import CanMixin from "@/mixins/CanMixin";
import { mapGetters, mapState } from "vuex";
import $ from "jquery";

export default {
    mixins: [CanMixin],
    computed: {
        ...mapState('Projects', ['image']),
        ...mapState('Scopes', ['scopesEnabled']),
        ...mapState('App', ['IDT']),
        ...mapGetters('User', ['isGuest']),
        isDisabled() {
            return !this.canUseColorGradingTools || !this.image || this.IDT.initial
        }
    },
    mounted() {
        this.$root.$refs.gamutCompressButton = this.$refs["gamut-compress-button"];
        this.$root.$refs.gamutCompressComponent = this;
    },
    methods: {
        setGamutCompress() {
            lutify.gamutCompress = !lutify.gamutCompress;
            this.$store.dispatch('UI/setGamutCompression', lutify.gamutCompress);

            lutify.blocks[1].gamutCompress = lutify.gamutCompress;
            gpu.composer.passes[3].enabled = lutify.gamutCompress;

            if (lutify.gamutCompress && lutify.fixBlueLightArtifacts) {
                this.$nextTick(() => {
                    this.$root.$refs.fixBlueLightButton.$el.click();
                })
            }

            gpu.render();
        },
    }
}
</script>